import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-card-actions',
    imports: [MatIconModule],
    templateUrl: './card-actions.component.html',
    styleUrl: './card-actions.component.scss'
})
export class CardActionsComponent {
  @Output() close = new EventEmitter<void>();
  @Input() heading: string = '';
  onClose(): void {
    this.close.emit();
  }
}
